//RTK
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//Lodash
import { get } from "lodash";

//Local imports
// import ServerConstants from "utils/ServerConstants";
import { PAGINATION } from "utils/constants/pagination";
import authApi from "interceptor/authInterceptor";
const { INITIAL_PAGE, ROWS_PER_PAGE } = PAGINATION;

// types
export type transactionDataProps = {
  transactionTableList: [];
  countStastics: [];
  totalTransactionItems: number;
  totalTransactionPages: number;
  pageNo: number;
  pageSize: number;
  loader: boolean;
  activeRequestId: string | null;
  error: null;
};

// initial state
const initialState: transactionDataProps = {
  transactionTableList: [],
  totalTransactionItems: 10,
  totalTransactionPages: 10,
  pageNo: INITIAL_PAGE,
  pageSize: ROWS_PER_PAGE,
  loader: false,
  activeRequestId: null,
  error: null,
  countStastics: []
};

// ==============================|| SLICE - TRANSACTION ||============================== //

const fetchTransactionData = createAsyncThunk(
  "transactionData/fetchTransactionData",

  async (
    args: {
      page: number;
      pageSize: number;
      fromDate: string | null;
      toDate: string | null;
      selectedCompanyId: string;
      pay_period_id: string | null;
      schedule_Id: string | null;
      business_Unit_Id: string | null;
      payrollId: string;
      employee: string;
    },
    { rejectWithValue }
  ) => {
    const {
      page,
      pageSize,
      fromDate,
      toDate,
      selectedCompanyId,
      pay_period_id,
      schedule_Id,
      business_Unit_Id,
      payrollId,
      employee,
    } = args;

    const startDate = !fromDate ? "" : fromDate;
    const endDate = !toDate ? "" : toDate;
    const size = pageSize < 5 ? 10 : pageSize;
    const payPeriodId = pay_period_id ? pay_period_id : "";
    const scheduleId = schedule_Id ? schedule_Id : "";
    const businessUnitId = business_Unit_Id ? business_Unit_Id : "";

    const response = await authApi.get(
      `/v2/api/timesheets/getAllDeductions?page=${page}&pageSize=${size}&company_id=${selectedCompanyId}&pay_period_id=${payPeriodId}&schedule_id=${scheduleId}&business_unit_id=${businessUnitId}&startDate=${startDate}&endDate=${endDate}&mode=0&isAll=0&payroll_id=${payrollId}&employee_name=${employee}`
    );

    if (!response.data) return rejectWithValue({ message: "No data" });

    const { data, totalRecords, totalPages, countStastics } = get(
      response,
      "data",
      {}
    );

    return {
      data,
      countStastics,
      totalRecords,
      totalPages,
      page,
      pageSize: size,
    };
  }
);

const transactionData = createSlice({
  name: "transactionData",
  initialState,
  reducers: {
    isLoading(state, action) {
      state.loader = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    },
    clearTransactions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactionData.pending, (state, action) => {
        state.loader = true;
        state.error = null;
        state.activeRequestId = action.meta.requestId;
      })
      .addCase(fetchTransactionData.fulfilled, (state, action) => {
        const { data, countStastics, totalRecords, totalPages, page, pageSize } =
          action.payload;

        // Prevent race-condition: only the latest request may update UI/state
        if (state.activeRequestId === action.meta.requestId) {
          state.transactionTableList =
            data || initialState.transactionTableList;
          state.countStastics = countStastics || initialState.countStastics;
          state.totalTransactionItems = totalRecords;
          state.totalTransactionPages = totalPages;
          state.pageNo = page || initialState.pageNo;
          state.pageSize = pageSize || initialState.pageSize;

          state.loader = false;
          state.activeRequestId = null;
        }
      })
      .addCase(fetchTransactionData.rejected, (state, action) => {
        state.error = (action.payload as any) ?? action.error;
        if (state.activeRequestId === action.meta.requestId) {
          state.loader = false;
          state.activeRequestId = null;
        }
      });
  },
});


export default transactionData.reducer;

export const { clearTransactions } = transactionData.actions;

export { fetchTransactionData };
